/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkflowFailureRecipient
 */
export interface WorkflowFailureRecipient {
    /**
     * 
     * @type {string}
     * @memberof WorkflowFailureRecipient
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowFailureRecipient
     */
    email: string;
    /**
     * 
     * @type {Date}
     * @memberof WorkflowFailureRecipient
     */
    createdAt?: Date | null;
}

/**
 * Check if a given object implements the WorkflowFailureRecipient interface.
 */
export function instanceOfWorkflowFailureRecipient(value: object): value is WorkflowFailureRecipient {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function WorkflowFailureRecipientFromJSON(json: any): WorkflowFailureRecipient {
    return WorkflowFailureRecipientFromJSONTyped(json, false);
}

export function WorkflowFailureRecipientFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowFailureRecipient {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function WorkflowFailureRecipientToJSON(json: any): WorkflowFailureRecipient {
    return WorkflowFailureRecipientToJSONTyped(json, false);
}

export function WorkflowFailureRecipientToJSONTyped(value?: WorkflowFailureRecipient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
    };
}

